import {
  FallProtectionIcon,
  FasteningSystemsIcon,
  QuestionMarkIcon,
  WaterproofingIcon,
} from "@rothoblaas/design-system";
import { FC } from "react";
import type { CATEGORY_CODE } from "../types";

export const categoryIcons: Record<CATEGORY_CODE, FC> = {
  "fastening-systems": FasteningSystemsIcon,
  "fall-protection": FallProtectionIcon,
  waterproofing: WaterproofingIcon,
};

export const getCategoryIcon = (categoryCode?: string): FC => {
  if (categoryCode && categoryCode in categoryIcons) {
    return categoryIcons[categoryCode as CATEGORY_CODE];
  }
  return QuestionMarkIcon;
};
